import templatesRoutes from "features/notification/templates/routes";
import configurationRoutes from "features/notification/configuration/routes";
import pauseRoutes from "features/notification/pause/routes";
import jobHistoryRoutes from "features/notification/jobHistory/routes";

import emailCredentialRoutes from "features/notification/credentialsEmail/routes";
import smsCredentialRoutes from "features/notification/credentialsSms/routes";
import whatsAppCredentialRoutes from "features/notification/credentialsWhatsApp/routes";
import firebaseCredentialRoutes from "features/notification/credentialsFirebase/routes";

import emailLogRoutes from "features/notification/logsEmail/routes";
import smsLogRoutes from "features/notification/logsSms/routes";
import whatsAppLogRoutes from "features/notification/logsWhatsApp/routes";
import pushLogRoutes from "features/notification/logsPush/routes";

const routes = {
  path: "notification",
  children: [
    templatesRoutes,
    configurationRoutes,
    {
      path: "credentials",
      children: [
        emailCredentialRoutes,
        smsCredentialRoutes,
        whatsAppCredentialRoutes,
        firebaseCredentialRoutes,
      ],
    },
    {
      path: "logs",
      children: [emailLogRoutes, smsLogRoutes, whatsAppLogRoutes, pushLogRoutes],
    },
    pauseRoutes,
    jobHistoryRoutes,
  ],
};

export default routes;
